// extracted by mini-css-extract-plugin
module.exports = {"component":"Logo_component__1RSL2","wrapper":"Logo_wrapper__2Nkwm","image":"Logo_image__DpYDo"};